export default __webpack_public_path__ + "static/media/sanofi.fb74436f.png";